import React from 'react';
import { Image } from '@themesberg/react-bootstrap';
import ReactLogo from "../assets/logo.webp";


export default (props) => {
  const { show } = props;

  return (
    <div
      className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"
        }`}
    >
      {show && (
        <div className="preloader bg-soft flex-column justify-content-center align-items-center">
          <Image
            className="logo-pulse"
            src={ReactLogo}
            height={60}
          />
        </div>
      )}

    </div>
  );
};
